// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalForm-space1-tK8Hm {
	margin-bottom: 6px !important;
}

.ModalForm-space2-ymhfV {
	margin-bottom: 12px !important;
}

.ModalForm-space3-Ae6pT {
	margin-bottom: 18px !important;
}

.ModalForm-space4-LbRhf {
	margin-bottom: 24px !important;
}

.ModalForm-space5-ZQ4s8 {
	margin-bottom: 30px !important;
}

.ModalForm-space6-XInYf {
	margin-bottom: 36px !important;
}

.ModalForm-space7-cX53W {
	margin-bottom: 42px !important;
}

.ModalForm-space8-xB75Q {
	margin-bottom: 48px !important;
}

.ModalForm-spaceTop1-OBW8t {
	margin-top: 6px !important;
}

.ModalForm-spaceTop2-OhoD4 {
	margin-top: 12px !important;
}

.ModalForm-spaceTop3-pi20K {
	margin-top: 18px !important;
}

.ModalForm-spaceTop4-C_iBL {
	margin-top: 24px !important;
}

.ModalForm-spaceTop5-eA8o0 {
	margin-top: 30px !important;
}

.ModalForm-spaceTop6-Q6rme {
	margin-top: 36px !important;
}

.ModalForm-spaceTop7-hOB3C {
	margin-top: 42px !important;
}

.ModalForm-spaceTop8-jOemD {
	margin-top: 48px !important;
}

.ModalForm-noMargin-gtA3T {
	margin: 0px !important;
}

.ModalForm-padding1-tdgyd {
	padding-bottom: 6px !important;
}

.ModalForm-padding2-mqxw7 {
	padding-bottom: 12px !important;
}

.ModalForm-padding3-PV8rr {
	padding-bottom: 18px !important;
}

.ModalForm-padding4-BDFwZ {
	padding-bottom: 24px !important;
}

.ModalForm-padding5-JSTZw {
	padding-bottom: 30px !important;
}

.ModalForm-padding6-RPcqm {
	padding-bottom: 36px !important;
}

.ModalForm-padding7-SEQRl {
	padding-bottom: 42px !important;
}

.ModalForm-paddingTop1-JDsfw {
	padding-top: 6px !important;
}

.ModalForm-paddingTop2-N7jeU {
	padding-top: 12px !important;
}

.ModalForm-paddingTop3-TfIhQ {
	padding-top: 18px !important;
}

.ModalForm-paddingTop4-q1wMh {
	padding-top: 24px !important;
}

.ModalForm-paddingTop5-CVL01 {
	padding-top: 30px !important;
}

.ModalForm-paddingTop6-sKF7a {
	padding-top: 36px !important;
}

.ModalForm-paddingTop7-eG3FJ {
	padding-top: 42px !important;
}

.ModalForm-noPadding-N5Zhg {
	padding: 0px !important;
}

.ModalForm-spaceMarginBottom0-Zq76O {
	margin-bottom: 0;
}

.ModalForm-textBold-ZBelu {
	font-weight: 500 !important;
}

.ModalForm-textBolder-iTCHQ {
	font-weight: 700 !important;
}

.ModalForm-textNormal-y5UDd {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ModalForm-textDarkBlue-VGRcf {
	color: rgb(20, 39, 94) !important;
}

.ModalForm-textLightBlue-htRp5 {
	color: rgb(57, 87, 106) !important;
}

.ModalForm-textLightSandleGreen-mK1AZ {
	color: rgb(76, 86, 41) !important;
}

.ModalForm-textLightBrown-XGMMb {
	color: rgb(115, 79, 33) !important;
}

.ModalForm-textMediumMaroon-hbXUC {
	color: rgb(87, 37, 51) !important;
}

.ModalForm-textBrown-X_9Hr {
	color: rgb(160, 47, 24) !important;
}

.ModalForm-textMaroon-i4tLz {
	color: rgb(155, 49, 67) !important;
}

.ModalForm-textDarkBrown-MYRJs {
	color: rgb(83, 18, 16) !important;
}

.ModalForm-textMediumBrown-w3kQc {
	color: rgb(142, 28, 10) !important;
}

.ModalForm-textSkyBlue-ZHPK1 {
	color: rgb(37, 117, 141) !important;
}

.ModalForm-textGray-ERrJy {
	color: rgb(77, 65, 51) !important;
}

.ModalForm-errorMessage-nHjC6 {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ModalForm-userText-JcVY1 {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ModalForm-panelHeader-whkBX {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ModalForm-exportSection-ercS1 {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ModalForm-exportSectionGridSub-UQHo5 {
	grid-template-columns: 50% 49% !important;
}

.ModalForm-exportText-h0k62 {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ModalForm-exportLinkImg-NjFYg {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ModalForm-exportImg-XAcyc {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ModalForm-linkBtn-OQTGt {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ModalForm-table-NxE4C {
	display: table;
}

.ModalForm-tableRow-vgoFu {
	display: table-row;
}

.ModalForm-tableCell-IOgy5 {
	display: table-cell;
	float: none;
}

.ModalForm-formGroup-Qm6_B {
	margin-bottom: 6px;
}

.ModalForm-marginTop0-Qu3Yw {
	margin-top: 0;
}

.ModalForm-marginBottom20-YVBCq {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ModalForm-bannerImageBg-afkRH {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ModalForm-bannerDelete-KJ9VH {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ModalForm-exportLink-O171d {
	padding-top: 10px;
	padding-right: 10px;
}

.ModalForm-seachContent-Iew5h {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ModalForm-marginBottom9-EVTVn {
	margin-bottom: 9px;
}

.ModalForm-spaceTop52-tWBnK {
	margin-top: 52px;
}

.ModalForm-profileViewInner-x27Ol {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ModalForm-profileViewMain-SNTAU {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ModalForm-profileViewlabel-_s4CG {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ModalForm-profileViewMainContent-JfQij {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ModalForm-reviewsFormStar-Y56qK {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ModalForm-reviewsFormStar-Y56qK svg {
	cursor: pointer;
}

.ModalForm-addLanguageText-KwFps {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ModalForm-exportSection-ercS1 {
		grid-template-columns: 100%;
	}

	.ModalForm-spaceTop52-tWBnK {
		margin-top: 18px;
	}

	.ModalForm-exportText-h0k62 {
		float: none;
		margin-top: 12px;
	}

	.ModalForm-exportSectionGridSub-UQHo5 {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ModalForm-profileViewlabel-_s4CG {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ModalForm-profileViewMainContent-JfQij {
		width: 100%;
		text-align: center;
	}

	.ModalForm-panelHeader-whkBX {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.ModalForm-container-AKXg4 {
    max-width: 380px;
    width: 100%;
    margin: 0 auto;
}

.ModalForm-labelMargin-v5dL_ {
    margin: 0px 0px 6px 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/ReservationManagement/ModalForm/ModalForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACvN3E;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AACA;IACI,kCAAkC;AACtC","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../../admin-common.css';\n.container {\n    max-width: 380px;\n    width: 100%;\n    margin: 0 auto;\n}\n.labelMargin {\n    margin: 0px 0px 6px 0px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ModalForm-space1-tK8Hm`,
	"space2": `ModalForm-space2-ymhfV`,
	"space3": `ModalForm-space3-Ae6pT`,
	"space4": `ModalForm-space4-LbRhf`,
	"space5": `ModalForm-space5-ZQ4s8`,
	"space6": `ModalForm-space6-XInYf`,
	"space7": `ModalForm-space7-cX53W`,
	"space8": `ModalForm-space8-xB75Q`,
	"spaceTop1": `ModalForm-spaceTop1-OBW8t`,
	"spaceTop2": `ModalForm-spaceTop2-OhoD4`,
	"spaceTop3": `ModalForm-spaceTop3-pi20K`,
	"spaceTop4": `ModalForm-spaceTop4-C_iBL`,
	"spaceTop5": `ModalForm-spaceTop5-eA8o0`,
	"spaceTop6": `ModalForm-spaceTop6-Q6rme`,
	"spaceTop7": `ModalForm-spaceTop7-hOB3C`,
	"spaceTop8": `ModalForm-spaceTop8-jOemD`,
	"noMargin": `ModalForm-noMargin-gtA3T`,
	"padding1": `ModalForm-padding1-tdgyd`,
	"padding2": `ModalForm-padding2-mqxw7`,
	"padding3": `ModalForm-padding3-PV8rr`,
	"padding4": `ModalForm-padding4-BDFwZ`,
	"padding5": `ModalForm-padding5-JSTZw`,
	"padding6": `ModalForm-padding6-RPcqm`,
	"padding7": `ModalForm-padding7-SEQRl`,
	"paddingTop1": `ModalForm-paddingTop1-JDsfw`,
	"paddingTop2": `ModalForm-paddingTop2-N7jeU`,
	"paddingTop3": `ModalForm-paddingTop3-TfIhQ`,
	"paddingTop4": `ModalForm-paddingTop4-q1wMh`,
	"paddingTop5": `ModalForm-paddingTop5-CVL01`,
	"paddingTop6": `ModalForm-paddingTop6-sKF7a`,
	"paddingTop7": `ModalForm-paddingTop7-eG3FJ`,
	"noPadding": `ModalForm-noPadding-N5Zhg`,
	"spaceMarginBottom0": `ModalForm-spaceMarginBottom0-Zq76O`,
	"textBold": `ModalForm-textBold-ZBelu`,
	"textBolder": `ModalForm-textBolder-iTCHQ`,
	"textNormal": `ModalForm-textNormal-y5UDd`,
	"textDarkBlue": `ModalForm-textDarkBlue-VGRcf`,
	"textLightBlue": `ModalForm-textLightBlue-htRp5`,
	"textLightSandleGreen": `ModalForm-textLightSandleGreen-mK1AZ`,
	"textLightBrown": `ModalForm-textLightBrown-XGMMb`,
	"textMediumMaroon": `ModalForm-textMediumMaroon-hbXUC`,
	"textBrown": `ModalForm-textBrown-X_9Hr`,
	"textMaroon": `ModalForm-textMaroon-i4tLz`,
	"textDarkBrown": `ModalForm-textDarkBrown-MYRJs`,
	"textMediumBrown": `ModalForm-textMediumBrown-w3kQc`,
	"textSkyBlue": `ModalForm-textSkyBlue-ZHPK1`,
	"textGray": `ModalForm-textGray-ERrJy`,
	"errorMessage": `ModalForm-errorMessage-nHjC6`,
	"userText": `ModalForm-userText-JcVY1`,
	"panelHeader": `ModalForm-panelHeader-whkBX`,
	"exportSection": `ModalForm-exportSection-ercS1`,
	"exportSectionGridSub": `ModalForm-exportSectionGridSub-UQHo5`,
	"exportText": `ModalForm-exportText-h0k62`,
	"exportLinkImg": `ModalForm-exportLinkImg-NjFYg`,
	"exportImg": `ModalForm-exportImg-XAcyc`,
	"linkBtn": `ModalForm-linkBtn-OQTGt`,
	"table": `ModalForm-table-NxE4C`,
	"tableRow": `ModalForm-tableRow-vgoFu`,
	"tableCell": `ModalForm-tableCell-IOgy5`,
	"formGroup": `ModalForm-formGroup-Qm6_B`,
	"marginTop0": `ModalForm-marginTop0-Qu3Yw`,
	"marginBottom20": `ModalForm-marginBottom20-YVBCq`,
	"bannerImageBg": `ModalForm-bannerImageBg-afkRH`,
	"bannerDelete": `ModalForm-bannerDelete-KJ9VH`,
	"exportLink": `ModalForm-exportLink-O171d`,
	"seachContent": `ModalForm-seachContent-Iew5h`,
	"marginBottom9": `ModalForm-marginBottom9-EVTVn`,
	"spaceTop52": `ModalForm-spaceTop52-tWBnK`,
	"profileViewInner": `ModalForm-profileViewInner-x27Ol`,
	"profileViewMain": `ModalForm-profileViewMain-SNTAU`,
	"profileViewlabel": `ModalForm-profileViewlabel-_s4CG`,
	"profileViewMainContent": `ModalForm-profileViewMainContent-JfQij`,
	"reviewsFormStar": `ModalForm-reviewsFormStar-Y56qK`,
	"addLanguageText": `ModalForm-addLanguageText-KwFps`,
	"container": `ModalForm-container-AKXg4`,
	"labelMargin": `ModalForm-labelMargin-v5dL_`
};
module.exports = ___CSS_LOADER_EXPORT___;
